import { createContext, useContext } from 'react';
import { InboxItem } from 'src/api/inboxes';

export type InboxDetailsContextType = {
  message: InboxItem | undefined;
  isLoading: boolean;
  isError: boolean;
};

export const InboxDetailsContext =
  createContext<InboxDetailsContextType | null>(null);
InboxDetailsContext.displayName = 'InboxDetailsContext';

export const useInboxDetailsContext = () => {
  const context = useContext(InboxDetailsContext);
  if (!context) {
    throw new Error(
      'useInboxDetailsContext must be used within a InboxDetailsContextProvider',
    );
  }
  return context;
};
